import { FC } from 'react';
import cn from 'classnames';
import Hidden from 'raydiant-elements/layout/Hidden';
import Text from '@raydiant/raydial/components/Text';
import { Plus } from '@raydiant/raydial/components/Icons';

interface MarketplaceCardProps {
  onClick: () => void;
}

const MarketplaceCard: FC<MarketplaceCardProps> = ({ onClick }) => {
  const renderDesktopCard = () => {
    return (
      <div
        className={cn(
          'h-[185px] rounded-[20px] shadow border-2 border-grey-100 flex-col justify-start items-start inline-flex cursor-pointer',
        )}
        onClick={() => onClick()}
      >
        <div className="w-[220px] h-[185px] p-4 rounded-t-[17px] items-center justify-center flex flex-col">
          <div className="p-4 rounded-full bg-gray-100 mb-4">
            <Plus />
          </div>
          <Text variant="body">Browse and add apps</Text>
        </div>
      </div>
    );
  };

  const renderMobileCard = () => {
    return (
      <div
        className="flex items-center p-3.5 gap-4 rounded-xl border border-gray-200 cursor-pointer w-full h-[66px]"
        onClick={onClick}
      >
        <div className="p-4 rounded-full bg-gray-100">
          <Plus />
        </div>
        <Text variant="body">Browse and add apps</Text>
      </div>
    );
  };

  return (
    <>
      <Hidden xsDown>{renderDesktopCard()}</Hidden>
      <Hidden smUp>{renderMobileCard()}</Hidden>
    </>
  );
};

export default MarketplaceCard;
